module.exports = __webpack_public_path__ + "fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font-awesome-4.7.0/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 1090
// module chunks = 24